import {AdminRoles, Roles, AdminRolesEnum, RolesEnum} from '../services/types'

export const adminRoles: AdminRoles[] = Object.values(AdminRolesEnum)
export const roles: Roles[] = Object.values(RolesEnum)
